import { Component } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { RouterOutlet, Router, Event, NavigationEnd } from '@angular/router';
import { BackToTopComponent } from './shared-components/back-to-top/back-to-top.component';
import { UILibIconService } from './ui-lib-icon.service';
import { NgxSpinnerModule } from "ngx-spinner";
import { GlobalSpinnerService } from './ui-framework/global-services/spinner-service/global-spinner.service';


@Component({
    selector: 'app-root',
    imports: [RouterOutlet, BackToTopComponent, NgxSpinnerModule],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {

    title = 'WBSRLM';

    constructor(
        private router: Router,
        private viewportScroller: ViewportScroller,
        iconService: UILibIconService,
        readonly spinnerService: GlobalSpinnerService,
    ) {
        // this.appInitService.init();
        this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationEnd) {
                // Scroll to the top after each navigation end
                this.viewportScroller.scrollToPosition([0, 0]);
            }
        });
        iconService.init();
    }
  get spinnerText(): string {
    if (this.spinnerService) {
      return this.spinnerService.spinnerText;
    }
    return "Working in background...."
  }
}